
import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState, useEffect, useRef } from 'react';
import { MenuItem, Checkbox, ListItemText, Tooltip } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import DialogActions from '@mui/material/DialogActions';


import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../../../../utils/fvAxios';


export default function NotificationsSetupEditandAdd({ ID, TAB, SETTRG, TRG, DATA, CLOSE, PageChange }) {
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const menuListRef = useRef(null);
    const scrollToTopOfOtions = () => {
        setTimeout(() => {
            if (menuListRef.current) {
                const children = menuListRef.current.children;
                if (children.length >= 2) {
                    const secondLastOption = children[children.length - 2];
                    if (secondLastOption) {
                        secondLastOption.scrollTop = 0;
                    }
                }
            }
        }, 5);
    };

    const [NotificationsSetupList, setNotificationsSetupList] = React.useState([]);
    const [notificationsSetupId, setNotificationsSetupId] = React.useState(TAB == 2 ? DATA?.type : "3");
    const [ClientList, setClientList] = React.useState([]);
    const [clientId, setClientId] = React.useState(TAB == 2 ? DATA?.clientID : "");
    const [ClientusersList, setClientusersList] = React.useState([]);
    const [clientusersListId, setClientusersListId] = useState(TAB == 2 ? DATA?.userIds?.split(",").map(r => r.trim()) : []);
    const [AdminusersList, setAdminusersList] = React.useState([]);
    const [adminusersListId, setAdminusersListId] = React.useState(TAB == 2 ? DATA?.adminUserIds?.split(",").map(r => r.trim()) : []);
    const [EmailTemplatesList, setEmailTemplatesList] = React.useState([]);
    const [emailTemplatesListId, setEmailTemplatesListId] = React.useState(TAB == 2 ? DATA?.emailTempateId : "");

    const [Dis, setDis] = React.useState(false);

    useEffect(() => {
        Details();
        ChangeClient(TAB == 2 ? DATA?.clientID : "");
    }, []);

    // useEffect(() => {
    //     // GetClientUsersData();

    // }, [clientId]);

    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);

        const resp = await axios.get("Prequalification/GetAdminUsersForNotifications");
        setAdminusersList(resp?.data?.data);

        const response = await axios.get("EmailTemplates/GetEmailTemplates");
        setEmailTemplatesList(response?.data?.data);

        const respo = await axios.get("SystemUser/NotificationsSetup");
        setNotificationsSetupList(respo?.data?.data);

    }
    const ChangeClient = async (e) => {
        setClientId(e);
        const res = await axios.get("SystemUser/GetClientUsersData?ClientId=" + e);
        setClientusersList(res?.data?.data);
    }
    // const GetClientUsersData = async () => {
    //     const res = await axios.get("SystemUser/GetClientUsersData?ClientId=" + clientId);
    //     setClientusersList(res?.data?.data);
    // }

    const SaveorDeleteNotifications = async () => {
        if (TAB == 1 || TAB == 2) {
            setDis(true);
            if (clientusersListId != "" && emailTemplatesListId != "") {    //&& adminusersListId != ""
                const USERIDS = ClientusersList?.filter(f => clientusersListId?.includes(f?.userId));
                const USERNAMES = !USERIDS || USERIDS?.length == 0 ? "" : USERIDS?.map((r) => r?.email);
                const ADMINIDS = AdminusersList.filter(f => adminusersListId?.includes(f?.userId));
                const ADMINNAMES = ADMINIDS?.map((r) => r?.email);
                const CLIENTUSERIDS = clientusersListId == "" ? "" : clientusersListId;
                const Data = {
                    "clientUserEmails": USERNAMES?.toString(),
                    "userIds": CLIENTUSERIDS?.toString(),
                    "clientId": clientId,
                    "type": notificationsSetupId,
                    "adminUserEmails": ADMINNAMES?.toString(),
                    "adminUserIds": adminusersListId?.toString(),
                    "emailTemplateId": emailTemplatesListId
                }

                const res = await axios.post("SystemUser/SaveAdminNotifications", Data);
                if (res?.data?.responseCode == 100) {
                    toastNotify(res?.data?.data, true);
                    PageChange("1");
                    SETTRG(!TRG);
                    CLOSE();
                    setDis(false);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    setDis(false);
                }
            } else {
                toastNotify("Please Enter Mandatory filds", false);
                setDis(false);
            }
        } else if (TAB == 3) {
            const resp = await axios.post("SystemUser/DeleteAdminNotification?Id=" + ID);
            if (resp?.data?.responseCode == 100) {
                toastNotify(resp?.data?.data, true);
                PageChange("1");
                SETTRG(!TRG);
                CLOSE();
            } else {
                toastNotify(resp?.data?.responseMessage, false);
            }


        }
    }

    return (

        <div>
            <ToastContainer />
            {TAB == 3 ? "Do you want to delete this Notification?"
                :
                <div>

                    <div className='mt-2'>
                        <span style={{ color: "#3E4A62" }}> Notification type <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            value={notificationsSetupId || ""}
                            onChange={(e) => setNotificationsSetupId(e.target.value)}
                            MenuProps={MenuProps}
                            disabled={TAB == 2}
                        >
                            {NotificationsSetupList?.map((r, i) =>
                                <MenuItem key={i} value={r?.value}>{r?.text}</MenuItem>)}
                        </Select>

                    </div>
                    <div className='mt-2' >
                        <span style={{ color: "#3E4A62" }}> Client <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px",
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            value={clientId || ""}
                            onChange={(e) => ChangeClient(e.target.value)}
                            MenuProps={MenuProps}
                            disabled={TAB == 2}
                        >
                            {ClientList?.map((r, i) =>
                                <MenuItem key={i} value={r?.value}>{r?.text}</MenuItem>
                            )}
                        </Select>

                    </div>
                    <div >
                        <span style={{ color: "#3E4A62" }}>Client users <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <Select
                            labelId="docs-label"
                            id="docs-select"
                            multiple
                            size='small'
                            sx={{ width: "320px", overflow: "hidden" }}
                            name="Site Safety Representive"
                            value={clientusersListId || []}
                            MenuProps={{
                                ref: menuListRef,
                                PaperProps: MenuProps.PaperProps,
                            }}
                            renderValue={(selected) =>
                                selected
                                    .map((value) => ClientusersList?.find((doc) => doc?.userId === value)?.name)
                                    .filter((text) => text !== undefined)
                                    .join(", ")
                            }
                            onChange={(e) => setClientusersListId(e.target.value)}
                        >
                            <MenuItem key="Select All" hidden={ClientusersList == ""}>
                                <Checkbox
                                    id="select-all-checkbox"
                                    indeterminate={
                                        clientusersListId?.length > 0 && clientusersListId?.length < ClientusersList?.length
                                    }
                                    checked={clientusersListId?.length === ClientusersList?.length}
                                    onChange={(event) => {
                                        if (event?.target?.checked) {
                                            setClientusersListId(ClientusersList?.map((doc) => doc?.userId));
                                            scrollToTopOfOtions();
                                        } else {
                                            setClientusersListId([]);
                                        }
                                    }}
                                />
                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                    Select All
                                </label>
                                {/* <ListItemText primary="Select All" /> */}
                            </MenuItem>
                            {ClientusersList?.map((r) => (
                                <MenuItem key={r?.userId} value={r?.userId}>
                                    <Checkbox checked={clientusersListId?.indexOf(r?.userId) > -1} />
                                    <ListItemText primary={r?.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div >
                        <span style={{ color: "#3E4A62" }}>Admin users </span>    {/* <span style={{ color: "red" }}>*</span> */}
                        <br />
                        <Select
                            labelId="docs-label"
                            id="docs-select"
                            multiple
                            size='small'
                            sx={{ width: "320px", overflow: "hidden" }}
                            name="Site Safety Representive"
                            value={adminusersListId || []}
                            MenuProps={{
                                ref: menuListRef,
                                PaperProps: MenuProps.PaperProps,
                            }}
                            renderValue={(selected) =>
                                selected
                                    .map((value) => AdminusersList?.find((doc) => doc?.userId === value)?.name)
                                    .filter((text) => text !== undefined)
                                    .join(", ")
                            }
                            onChange={(e) => setAdminusersListId(e.target.value)}
                        >
                            <MenuItem key="Select All" hidden={AdminusersList == ""}>
                                <Checkbox
                                    id="select-all-checkbox"
                                    indeterminate={
                                        adminusersListId?.length > 0 && adminusersListId?.length < AdminusersList?.length
                                    }
                                    checked={adminusersListId?.length === AdminusersList?.length}
                                    onChange={(event) => {
                                        if (event?.target?.checked) {
                                            setAdminusersListId(AdminusersList?.map((doc) => doc?.userId));
                                            scrollToTopOfOtions();
                                        } else {
                                            setAdminusersListId([]);
                                        }
                                    }}
                                />
                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                    Select All
                                </label>
                                {/* <ListItemText primary="Select All" /> */}
                            </MenuItem>
                            {AdminusersList?.map((r) => (
                                <MenuItem key={r?.userId} value={r?.userId}>
                                    <Checkbox checked={adminusersListId?.indexOf(r?.userId) > -1} />
                                    <ListItemText primary={r?.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </div>

                    <div className='mt-2'>
                        <span style={{ color: "#3E4A62" }}>Email Templates  <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            value={emailTemplatesListId || ""}
                            onChange={(e) => setEmailTemplatesListId(e.target.value)}
                            MenuProps={MenuProps}
                        >
                            {EmailTemplatesList?.map((r, i) =>
                                <MenuItem key={i} title={r?.value} value={r?.key}>{r?.value}</MenuItem>)}
                        </Select>

                    </div>
                </div>
            }
            <DialogActions >
                <div className="login-help__buttonContainer mt-4">
                    <Button variant="contained" className="login-help-button-cancel mx-2" onClick={CLOSE}>Cancel</Button>
                    <Button variant="contained" disabled={Dis} className="login-button-request mx-2" onClick={SaveorDeleteNotifications}>{TAB == 3 ? "Ok" : TAB == 1 ? "Add " : "Save"}</Button>
                </div>
            </DialogActions>
        </div >


    )
}
